module.exports = __webpack_public_path__ + "img/343.1ab78635.jpg";